<template functional>
  <svg :class="[data.class, data.staticClass, 'stella-icon']" :style="data.staticStyle" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path v-if="props.filled" d="M12 2.5L2 11.5H5.5V21.5H10.5V15.5H13.5V21.5H18.5V11.5H22L12 2.5Z" fill="currentColor"/>
    <path v-else d="M12 3.2L3.5 11.2H6V20.5H10V14.5H14V20.5H18V11.2H20.5L12 3.2ZM12 5.5L16.5 9.7V19H15.5V13H8.5V19H7.5V9.7L12 5.5Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconHome",
  props: {
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
